module.exports = __webpack_public_path__ + "img/Tux Pacific.74115052.jpg";